interface CarrouselArrowIconProps {
  onClick?: (e: unknown) => void
  type: 'next' | 'prev'
}

function CarrouselArrowIcon({ onClick, type }: CarrouselArrowIconProps) {
  return (
    <div
      className={`stroke-primary-dark absolute top-[30px] z-30 m-0 flex h-[16.325rem] items-center ${
        type === 'next' ? 'right-0' : 'left-0'
      }  `}
      onClick={onClick}
    >
      {type === 'next' ? (
        <img
          src='/assets/icons/arrow/slider-button.svg'
          alt='Next'
          className='h-[48px] w-[48px] rotate-180'
        />
      ) : (
        <img
          src='/assets/icons/arrow/slider-button.svg'
          alt='Prev'
          className='h-[48px] w-[48px]'
        />
      )}
    </div>
  )
}

export default CarrouselArrowIcon
